import { ButtonProps } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import { useFormStatus } from "react-dom";

export const ChatInboxChannelFormSubmitButton = (
  props: Omit<ButtonProps, "type" | "aria-disabled">,
) => {
  const { pending } = useFormStatus();
  return (
    <LoadingButton
      {...props}
      type="submit"
      aria-disabled={pending}
      loading={pending}
    >
      Start Chat
    </LoadingButton>
  );
};
